<template>
    <div class="agent-management">
      <h1>代理管理</h1>
      <!-- 代理管理内容 -->
    </div>
  </template>
  
  <script>
  export default {
    name: 'AgentManagement'
  }
  </script>
  
  <style scoped>
  .agent-management {
    padding: 20px;
  }
  </style>